import { useAquariums } from './useAquariums';
import { isZeovitSupplySystem } from '../utils/supplySystem';

/**
 * Whether the ZeoVit module is available for an aquarium (#1784): only when its
 * supply system is ZeoVit.
 *
 * - `loading`: the aquarium list is still loading.
 * - `available`: the aquarium's supply system is ZeoVit.
 * - `unavailable`: the aquarium is known and uses another (or no) supply system.
 * - `unknown`: the aquarium list failed or does not contain the aquarium. The pages
 *   then render as before and the backend gate (409 SUPPLY_SYSTEM_NOT_ZEOVIT) decides.
 *
 * Reads the shared ['aquariums'] query, which the app root (ActiveAquariumDataProvider)
 * already loads — no extra request.
 */
export type ZeovitAvailability = 'loading' | 'available' | 'unavailable' | 'unknown';

export function useZeovitAvailability(aquariumId: string | undefined): ZeovitAvailability {
  const { data, isLoading } = useAquariums();
  if (!aquariumId) return 'unknown';
  if (isLoading && !data) return 'loading';
  const aquarium = data?.find((a) => a.id === aquariumId);
  if (!aquarium) return 'unknown';
  return isZeovitSupplySystem(aquarium.supplySystem) ? 'available' : 'unavailable';
}
